(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vendor-tabs"] && !Shopify.designMode) return;
  try {
    
class VendorTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab-target]'));
    this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tabTarget));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });

    this.activate(this.tabs[0].dataset.tabTarget);
  }

  onKeydown(event) {
    const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;
    event.preventDefault();

    const current = this.tabs.findIndex((tab) => tab.classList.contains('is-active'));
    let next = current;

    if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.tabs.length - 1;

    this.activate(this.tabs[next].dataset.tabTarget);
    this.tabs[next].focus();
  }

  activate(id) {
    this.tabs.forEach((tab) => {
      const isOn = tab.dataset.tabTarget === id;
      tab.classList.toggle('is-active', isOn);
      tab.setAttribute('aria-selected', isOn ? 'true' : 'false');
      tab.setAttribute('tabindex', isOn ? '0' : '-1');
    });
    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.tabPanel === id);
    });
  }
}

if (!customElements.get('vendor-tabs')) {
  customElements.define('vendor-tabs', VendorTabs);
}

  } catch(e) { console.error(e); }
})();
})();
